module.exports = ["Fine","Diminuitive","Tiny","Small","Medium","Large","Huge","Gargantuan","Colossal"]


//////////////////
// WEBPACK FOOTER
// ./src/data/sizes.json
// module id = rvl+
// module chunks = 1